import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";

export default function AgentNoteList() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [editUser, setEditUser] = useState({});
    const [formData1, setFormData1] = useState({
        note: "",
    });
    const [agents, setAgents] = useState([]);
    const [selectedAgentId, setSelectedAgentId] = useState("");

    useEffect(() => {
        fetchTaskDetails();
        fetchAgents();
    }, []);

    const fetchAgents = () => {
        http.get(`/agent?company_id=${user.company_id}`).then((res) => {
            if (Array.isArray(res.data.data)) {
                setAgents(res.data.data);
            }
        });
    };

    const fetchTaskDetails = () => {
        setIsLoading(true);
        let endpoint = `/agent_note?company_id=${user.company_id}`;
        if (selectedAgentId) {
            endpoint += `&agent_id=${selectedAgentId}`;
        }

        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (res.data.status === 'success' && Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };

    const handleChangeModal = (e) => {
        setFormData1({
            ...formData1,
            [e.target.name]: e.target.value,
        });
    };

    const deleteTask = async (taskId) => {
        if (window.confirm("Are you sure you want to delete this note?")) {
            await http
                .delete(`/agent_note_delete/${taskId}`)
                .then((response) => {
                    toast.success("Note deleted successfully !");
                    fetchTaskDetails();
                })
                .catch((err) => {
                    console.error("Error deleting task", err);
                    toast.error("Failed to delete note");
                });
        }
    };

    const openEditModal = async (taskAll) => {
        setShowModal(true);
        setFormData1({
            note: taskAll.note || "",
        });
        setEditUser(taskAll);
    };

    const saveEditedCustemer = async (e) => {
        e.preventDefault();
        try {
            if (!editUser || !editUser.id) {
                console.error("No user data to edit.");
                return;
            }

            const response = await http.put(`/agent_note_update/${editUser.id}`, formData1);

            if (response.data.status === 'success') {
                toast.success("Note updated successfully!");
                setShowModal(false);
                fetchTaskDetails();
            }
        } catch (error) {
            console.error("Error updating note", error);
            toast.error("An error occurred while updating the note.");
        }
        setEditUser({});
    };

    const closeModal = () => {
        setShowModal(false);
        setEditUser({});
    };

    const handleAgentFilter = (e) => {
        setSelectedAgentId(e.target.value);
    };

    useEffect(() => {
        if (selectedAgentId !== undefined) {
            fetchTaskDetails();
        }
    }, [selectedAgentId]);

    return (
        <>
            <Toaster />
            {showModal && (
                <form onSubmit={saveEditedCustemer}>
                    <div className="modal" tabIndex="-1" style={{ display: "block" }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Note</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closeModal}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group mt-3">
                                        <label>Note</label>
                                        <textarea
                                            name="note"
                                            className="form-control"
                                            rows="5"
                                            value={formData1.note}
                                            onChange={handleChangeModal}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closeModal}
                                    >
                                        Close
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Save changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}

            <div className="container mt-1">
                <div className="row">
                    <div className="col-md-6">
                        <h1>Agent Notes</h1>
                    </div>
                    <div className="col-md-6 text-end">
                        <Link className="add_link mb-3" to="/agent_note_add">
                            Add Note
                        </Link>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-4">
                        <label>Filter by Agent</label>
                        <select
                            className="form-control"
                            value={selectedAgentId}
                            onChange={handleAgentFilter}
                        >
                            <option value="">All Agents</option>
                            {agents.map((agent) => (
                                <option key={agent.id} value={agent.id}>
                                    {agent.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="table-responsive">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : (
                        <table className="table table-striped">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-danger">No</th>
                                    <th>Agent Name</th>
                                    <th>Note</th>
                                    <th>Created By</th>
                                    <th>Created At</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.length > 0 ? (
                                    tasks.map((taskuser, index) => (
                                        <tr key={taskuser.id}>
                                            <td>{index + 1}</td>
                                            <td>{taskuser.agent ? taskuser.agent.name : '-'}</td>
                                            <td style={{ maxWidth: '400px', wordWrap: 'break-word' }}>
                                                {taskuser.note}
                                            </td>
                                            <td>
                                                {taskuser.user ? `${taskuser.user.name} ${taskuser.user.last_name || ''}` : '-'}
                                            </td>
                                            <td>{moment(taskuser.created_at).format("DD MMM, YYYY HH:mm")}</td>
                                            <td>
                                                {user.status === 1 && (
                                                    <>
                                                        <button
                                                            className="btn btn-sm btn-link"
                                                            onClick={() => openEditModal(taskuser)}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-link text-danger"
                                                            onClick={() => deleteTask(taskuser.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No notes found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </>
    );
}

